import DashboardIcon from "../../../Utils/icons/pages/Dashboard.png";
import ProspectsIcon from "../../../Utils/icons/pages/Prospects.png";
import QuotesIcon from "../../../Utils/icons/pages/Quotes.png";
import ClientsIcon from "../../../Utils/icons/pages/Clients.png";
import CommissionsIcon from "../../../Utils/icons/pages/Commissions.png";
import ucare from "../../../Utils/icons/enhancedCare.png";
import salesPerformance from "../../../Utils/icons/createQuoteHealthInsuranceIcon.png";
import audit from "../../../Utils/icons/clinetsCompanyPhoto.png";
import addUser from "../../../Utils/icons/addUser.svg";
import debtManagement from "../../../Utils/icons/broadVeiw.png";
import { ANY_QUOTE_ACCESS, PERM } from "../../../Utils/access/permissionConstants";

/**
 * Sidebar config: `access` drives visibility via /me/access permission keys.
 * - `public`: any authenticated user
 * - `requirePrivileged`: Ginja `user.is_privileged` only
 * - `orPrivilege` + `requiredAny`: key match OR privileged (e.g. audit)
 */
export const sidebarNavGroups = [
  {
    label: "Main",
    items: [
      { name: "Dashboard", path: "/", icon: DashboardIcon, access: { public: true } },
      {
        name: "Prospects",
        path: "/prospects",
        icon: ProspectsIcon,
        access: { requiredAny: [PERM.GET_LEADS] },
      },
      {
        name: "Quotes",
        path: "/quotes",
        icon: QuotesIcon,
        access: { requiredAny: ANY_QUOTE_ACCESS },
      },
      {
        name: "Policies",
        path: "/policies",
        icon: ClientsIcon,
        access: { requiredAny: [PERM.GET_POLICIES] },
      },
      {
        name: "Commissions",
        path: "/commissions",
        icon: CommissionsIcon,
        access: { requiredAny: [PERM.GET_COMMISSIONS] },
      },
      {
        name: "Debt Management",
        path: "/debt-management",
        icon: debtManagement,
        access: { requiredAny: [PERM.GET_DEBT_MANAGMENT] },
      },
    ],
  },
  {
    label: "Tools",
    items: [
      { name: "U-Care", path: "/ucare", icon: ucare, external: true, access: { public: true } },
      {
        name: "Sales Performance",
        path: "/sales-performance",
        icon: salesPerformance,
        access: { public: true },
      },
    ],
  },
  {
    label: "Settings & Logs",
    items: [
      {
        name: "Audit Log",
        path: "/audit-log",
        icon: audit,
        access: { requiredAny: [PERM.ACCESS_CONTROL], orPrivilege: true },
      },
      {
        name: "Users",
        path: "/users",
        icon: addUser,
        access: { requirePrivileged: true },
      },
    ],
  },
];
